const loadFont = (fontFamily: any) => {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = fontFamily;
  document.head.appendChild(link);
};
export { loadFont };
